import { fetchApi } from '@/config/axiosSetting';
import {
  GetCulpritVehicleCorrectiveImagesFormTabsParamsType,
  GetCulpritVehicleCorrectiveImagesFormTabsResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritVehicleCorrectiveImagesFormTabs/getCulpritVehicleCorrectiveImagesFormTabs.type';

export const getCulpritVehicleCorrectiveImagesFormTabsFunction = (
  params: GetCulpritVehicleCorrectiveImagesFormTabsParamsType,
): Promise<GetCulpritVehicleCorrectiveImagesFormTabsResponseType> =>
  fetchApi.get(
    `/property/reports/${params.id}/accident_users/culprit/images/corrective/form/entry_tabs/`,
  );
